var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-design"
  }, [_c("div", {
    staticClass: "table-show"
  }, [_c("div", {
    staticClass: "save-btn"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.saveTable
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1), _c("h2", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("预览区")))]), _c("div", {
    staticClass: "table-part"
  }, [_c("p", {
    staticClass: "table-title"
  }, [_vm._v(_vm._s(_vm.tableForm.name))]), _c("div", {
    ref: "hotTable",
    staticClass: "table-example"
  })])]), _c("div", {
    staticClass: "table-setting"
  }, [_c("div", {
    staticClass: "title-part"
  }, [_vm._v(_vm._s(_vm.$t("表格设置")))]), _c("a-form-model", {
    ref: "tableForm",
    attrs: {
      model: _vm.tableForm,
      rules: _vm.dataRule,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("表格名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("表格名称")
    },
    model: {
      value: _vm.tableForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "name", $$v);
      },
      expression: "tableForm.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("表格标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: "",
      "max-length": 15,
      placeholder: _vm.$t("请输入") + _vm.$t("表格标识")
    },
    model: {
      value: _vm.tableForm.mark,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "mark", $$v);
      },
      expression: "tableForm.mark"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("隐藏表头"),
      prop: "tableHead"
    }
  }, [_c("div", {
    staticClass: "one-line-class"
  }, [_c("a-switch", {
    attrs: {
      disabled: _vm.tableInitInfo.tableType === "fixed"
    },
    on: {
      change: _vm.tableHeaderSwitch
    },
    model: {
      value: _vm.tableForm.tableHead,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "tableHead", $$v);
      },
      expression: "tableForm.tableHead"
    }
  }), _c("a-input-number", {
    staticStyle: {
      width: "80px",
      "margin-left": "10px"
    },
    attrs: {
      precision: 0,
      disabled: true,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("列数")
    },
    model: {
      value: _vm.tableForm.tabHeadLineNum,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "tabHeadLineNum", $$v);
      },
      expression: "tableForm.tabHeadLineNum"
    }
  })], 1)])], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("隐藏表尾"),
      prop: "tableTail"
    }
  }, [_c("a-switch", {
    on: {
      change: _vm.tableTailChange
    },
    model: {
      value: _vm.tableForm.tableTail,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "tableTail", $$v);
      },
      expression: "tableForm.tableTail"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "title-part"
  }, [_vm._v(" " + _vm._s(_vm.$t("列设置")) + " ")]), _c("div", {
    staticClass: "row-container"
  }, _vm._l(_vm.showColumns, function (item, index) {
    return _c("a-popover", {
      key: item.dataIndex,
      staticStyle: {
        width: "400px"
      },
      attrs: {
        placement: "bottomLeft",
        overlayStyle: {
          width: "400px",
          paddingTop: 0
        },
        trigger: "click"
      }
    }, [_c("template", {
      slot: "content"
    }, [_c("h4", [_vm._v(_vm._s(item.name))]), _vm.tableInitInfo.tableUsage === "control" ? _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("控件")
      }
    }, [_c("a-select", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        placeholder: _vm.$t("请选择") + _vm.$t("控件"),
        disabled: index === 0 && _vm.autoincrement
      },
      model: {
        value: item.control,
        callback: function ($$v) {
          _vm.$set(item, "control", $$v);
        },
        expression: "item.control"
      }
    }, [_c("a-select-option", {
      attrs: {
        value: "text"
      }
    }, [_vm._v(_vm._s(_vm.$t("单行文本")))]), _c("a-select-option", {
      attrs: {
        value: "radio"
      }
    }, [_vm._v(_vm._s(_vm.$t("单选")))]), _c("a-select-option", {
      attrs: {
        value: "date"
      }
    }, [_vm._v(_vm._s(_vm.$t("日期选择")))]), _c("a-select-option", {
      attrs: {
        value: "number"
      }
    }, [_vm._v(_vm._s(_vm.$t("数字")))])], 1)], 1) : _vm._e(), item.control && _vm.tableInitInfo.tableUsage === "control" ? _c("div", {
      staticStyle: {
        margin: "5px 0px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("范围:")) + " ")]) : _vm._e(), item.control === "text" && _vm.tableInitInfo.tableUsage === "control" ? _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("字数限制"),
        "label-col": {
          span: 6
        },
        "wrapper-col": {
          span: 18
        }
      }
    }, [_c("a-input-number", {
      staticStyle: {
        width: "100px"
      },
      attrs: {
        "controls-position": "right",
        min: 0,
        disabled: index === 0 && _vm.autoincrement,
        max: Number(item.textLengthMaxValue),
        precision: 0,
        parser: value => value.replace(/[^\d]/g, "")
      },
      model: {
        value: item.textLengthMinValue,
        callback: function ($$v) {
          _vm.$set(item, "textLengthMinValue", $$v);
        },
        expression: "item.textLengthMinValue"
      }
    }), _vm._v(" " + _vm._s("-") + " "), _c("a-input-number", {
      staticStyle: {
        width: "100px"
      },
      attrs: {
        "controls-position": "right",
        min: 0,
        disabled: index === 0 && _vm.autoincrement,
        max: 200,
        precision: 0,
        parser: value => value.replace(/[^\d]/g, "")
      },
      model: {
        value: item.textLengthMaxValue,
        callback: function ($$v) {
          _vm.$set(item, "textLengthMaxValue", $$v);
        },
        expression: "item.textLengthMaxValue"
      }
    })], 1) : _vm._e(), item.control === "number" ? _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("数值限制"),
        "label-col": {
          span: 6
        },
        "wrapper-col": {
          span: 18
        }
      }
    }, [_c("a-input-number", {
      staticStyle: {
        width: "100px"
      },
      attrs: {
        "controls-position": "right",
        min: 0,
        disabled: index === 0 && _vm.autoincrement,
        max: Number(item.numberMaxValue),
        precision: 0,
        parser: value => value.replace(/[^\d]/g, "")
      },
      model: {
        value: item.numberMinValue,
        callback: function ($$v) {
          _vm.$set(item, "numberMinValue", $$v);
        },
        expression: "item.numberMinValue"
      }
    }), _vm._v(" " + _vm._s("-") + " "), _c("a-input-number", {
      staticStyle: {
        width: "100px"
      },
      attrs: {
        "controls-position": "right",
        min: 0,
        disabled: index === 0 && _vm.autoincrement,
        max: 200,
        precision: 0,
        parser: value => value.replace(/[^\d]/g, "")
      },
      model: {
        value: item.numberMaxValue,
        callback: function ($$v) {
          _vm.$set(item, "numberMaxValue", $$v);
        },
        expression: "item.numberMaxValue"
      }
    })], 1) : _vm._e(), item.control === "radio" && _vm.tableInitInfo.tableUsage === "control" ? _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("选项值"),
        "label-col": {
          span: 6
        },
        "wrapper-col": {
          span: 18
        }
      }
    }, [_c("a-input", {
      attrs: {
        disabled: index === 0 && _vm.autoincrement,
        placeholder: _vm.$t("请填写控件选项，不同选项用“;”隔开(英文)")
      },
      model: {
        value: item.optionValues,
        callback: function ($$v) {
          _vm.$set(item, "optionValues", $$v);
        },
        expression: "item.optionValues"
      }
    })], 1) : _vm._e(), item.control === "date" && _vm.tableInitInfo.tableUsage === "control" ? _c("a-row", [_c("a-select", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        placeholder: _vm.$t("请选择") + _vm.$t("日期格式"),
        disabled: index === 0 && _vm.autoincrement
      },
      model: {
        value: item.dateType,
        callback: function ($$v) {
          _vm.$set(item, "dateType", $$v);
        },
        expression: "item.dateType"
      }
    }, _vm._l(_vm.dateTypeOptions, function (item) {
      return _c("a-select-option", {
        key: item,
        attrs: {
          value: item
        }
      }, [_vm._v(_vm._s(item))]);
    }), 1)], 1) : _vm._e(), _vm.tableInitInfo.tableUsage === "template" ? _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("关联数据源")
      }
    }, [_c("a-select", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        placeholder: _vm.$t("请选择") + _vm.$t("关联数据源"),
        disabled: index === 0 && _vm.autoincrement
      },
      on: {
        change: e => _vm.typeChange(item)
      },
      model: {
        value: item.type,
        callback: function ($$v) {
          _vm.$set(item, "type", $$v);
        },
        expression: "item.type"
      }
    }, [_c("a-select-option", {
      attrs: {
        value: "system"
      }
    }, [_vm._v(_vm._s(_vm.$t("系统内置")))]), _c("a-select-option", {
      attrs: {
        value: "dynamic"
      }
    }, [_vm._v(_vm._s(_vm.$t("动态获取")))])], 1), _c("a-cascader", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        options: item.type === "system" ? _vm.computedFormatSystemData : item.type === "dynamic" ? _vm.computedFormatDynamicData : item.type === "filter" ? _vm.computedFormatFilterData : [],
        placeholder: _vm.$t("请手动关联数据源"),
        disabled: index === 0 && _vm.autoincrement,
        notFoundContent: _vm.$t("暂无数据"),
        popupClassName: "cascader-relation-data-source"
      },
      on: {
        change: (e, selectedOptions) => _vm.onMarkChange(e, selectedOptions, item, index)
      },
      scopedSlots: _vm._u([{
        key: "displayRender",
        fn: function ({
          labels,
          selectedOptions
        }) {
          return _vm._l(labels, function (label, index) {
            return _c("span", {
              key: selectedOptions[index].id
            }, [_vm._v(_vm._s(typeof label === "object" ? label.data.attrs.value : _vm.$t(label) + "/") + " ")]);
          });
        }
      }], null, true),
      model: {
        value: item.mark,
        callback: function ($$v) {
          _vm.$set(item, "mark", $$v);
        },
        expression: "item.mark"
      }
    })], 1) : _vm._e(), _vm.tableInitInfo.tableUsage === "control" ? _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("关联数据源")
      }
    }, [_c("a-input", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        disabled: ""
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    })], 1) : _vm._e(), _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("列尾")
      }
    }, [_c("a-input", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        placeholder: _vm.$t("请输入") + _vm.$t("列尾"),
        disabled: index === 0 && _vm.autoincrement,
        "max-length": 50
      },
      on: {
        change: e => _vm.settingTail(e, item, index)
      },
      model: {
        value: item.tail,
        callback: function ($$v) {
          _vm.$set(item, "tail", $$v);
        },
        expression: "item.tail"
      }
    })], 1), _c("a-form-model-item", {
      staticStyle: {
        "margin-bottom": "0"
      },
      attrs: {
        label: _vm.$t("关联函数")
      }
    }, [_c("a-select", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        placeholder: _vm.$t("请选择") + _vm.$t("关联函数"),
        disabled: index === 0 && _vm.autoincrement,
        allowClear: ""
      },
      on: {
        change: e => _vm.settingTail(e, item, index)
      },
      model: {
        value: item.function,
        callback: function ($$v) {
          _vm.$set(item, "function", $$v);
        },
        expression: "item.function"
      }
    }, _vm._l(item.functionDataSource, function (funcItem) {
      return _c("a-select-option", {
        key: funcItem.id,
        attrs: {
          value: funcItem.mark
        }
      }, [_vm._v(_vm._s(funcItem.name))]);
    }), 1)], 1), _c("a-form-model-item", {
      attrs: {
        label: _vm.$t("宽度设置")
      }
    }, [_c("a-select", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        disabled: index === 0 && _vm.autoincrement,
        placeholder: _vm.$t("请选择宽度")
      },
      model: {
        value: item.widthSet,
        callback: function ($$v) {
          _vm.$set(item, "widthSet", $$v);
        },
        expression: "item.widthSet"
      }
    }, _vm._l(_vm.widthSetOptins, function (item) {
      return _c("a-select-option", {
        key: item,
        attrs: {
          value: item
        }
      }, [_vm._v(_vm._s(item))]);
    }), 1)], 1), _c("div", {
      staticClass: "style-setting"
    }, [_vm._v(" " + _vm._s(_vm.$t("样式设置") + ":") + " "), _c("svg-icon", {
      class: ["style-setting-icon", item["font"] ? "select-icon" : ""],
      attrs: {
        icon: "font",
        size: 18
      },
      nativeOn: {
        click: function ($event) {
          return _vm.columnStyleSetting("font", item, index);
        }
      }
    }), _c("a-icon", {
      class: ["style-setting-icon", item["bold"] ? "select-icon" : ""],
      staticStyle: {
        "font-size": "20px"
      },
      attrs: {
        type: "bold"
      },
      on: {
        click: function ($event) {
          return _vm.columnStyleSetting("bold", item, index);
        }
      }
    }), _c("a-icon", {
      class: ["style-setting-icon", item["italic"] ? "select-icon" : ""],
      attrs: {
        type: "italic"
      },
      on: {
        click: function ($event) {
          return _vm.columnStyleSetting("italic", item, index);
        }
      }
    }), _c("a-icon", {
      class: ["style-setting-icon", item["underline"] ? "select-icon" : ""],
      attrs: {
        type: "underline"
      },
      on: {
        click: function ($event) {
          return _vm.columnStyleSetting("underline", item, index);
        }
      }
    }), _c("a-icon", {
      class: ["style-setting-icon", item["fontSize"] ? "select-icon" : ""],
      attrs: {
        type: "font-size"
      },
      on: {
        click: function ($event) {
          return _vm.columnStyleSetting("fontSize", item, index);
        }
      }
    })], 1), item.activeStyleIcon === "font" && item["font"] ? _c("a-select", {
      ref: "select",
      refInFor: true,
      staticStyle: {
        width: "120px"
      },
      model: {
        value: item.fontFamily,
        callback: function ($$v) {
          _vm.$set(item, "fontFamily", $$v);
        },
        expression: "item.fontFamily"
      }
    }, _vm._l(_vm.fontFamilySelectOption, function (item) {
      return _c("a-select-option", {
        key: item,
        attrs: {
          value: item
        }
      }, [_vm._v(_vm._s(item === "默认字体" ? _vm.$t("默认字体") : item))]);
    }), 1) : _vm._e(), item.activeStyleIcon === "fontSize" && item["fontSize"] ? _c("a-select", {
      ref: "select",
      refInFor: true,
      staticStyle: {
        width: "120px"
      },
      model: {
        value: item.size,
        callback: function ($$v) {
          _vm.$set(item, "size", $$v);
        },
        expression: "item.size"
      }
    }, _vm._l(_vm.fontSizeSelectOption, function (item) {
      return _c("a-select-option", {
        key: item,
        attrs: {
          value: item
        }
      }, [_vm._v(_vm._s(item))]);
    }), 1) : _vm._e()], 1), _c("span", {
      staticClass: "row-item-class"
    }, [_c("svg-icon", {
      staticClass: "row-icon",
      attrs: {
        icon: "row",
        size: 18
      }
    }), _c("a", {
      staticClass: "row-name"
    }, [_vm._v(_vm._s(item.name))]), index === 0 && _vm.tableInitInfo.tableType === "increment" ? _c("a-checkbox", {
      staticStyle: {
        float: "right",
        "margin-bottom": "5px",
        "margin-right": "10px"
      },
      attrs: {
        checked: _vm.autoincrement
      },
      on: {
        click: e => _vm.changeAutoIncrement(e, item)
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("自增")) + " ")]) : _vm._e()], 1)], 2);
  }), 1), _vm.tableInitInfo.tableType === "increment" ? _c("a-checkbox", {
    staticStyle: {
      float: "right",
      "margin-bottom": "5px"
    },
    model: {
      value: _vm.tableForm.isForm,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "isForm", $$v);
      },
      expression: "tableForm.isForm"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("表单形式")) + " ")]) : _vm._e(), _c("div", {
    staticClass: "title-part"
  }, [_vm._v(_vm._s(_vm.$t("表头设置") + ":"))]), _c("div", {
    staticClass: "cell-setting-part"
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-select", {
    ref: "select",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择")
    },
    model: {
      value: _vm.cellSettings.selectRowKey,
      callback: function ($$v) {
        _vm.$set(_vm.cellSettings, "selectRowKey", $$v);
      },
      expression: "cellSettings.selectRowKey"
    }
  }, _vm._l(_vm.cellSettings.rowOptions, function (item) {
    return _c("a-select-option", {
      key: item.label + item.value,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(item.label.replace("行", "row")))]);
  }), 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-select", {
    ref: "select",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择")
    },
    model: {
      value: _vm.cellSettings.selectColumnKey,
      callback: function ($$v) {
        _vm.$set(_vm.cellSettings, "selectColumnKey", $$v);
      },
      expression: "cellSettings.selectColumnKey"
    }
  }, _vm._l(_vm.cellSettings.columnOptions, function (item) {
    return _c("a-select-option", {
      key: item.label + item.value,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(item.label.replace("列", "col")))]);
  }), 1)], 1)], 1), Object.keys(_vm.computedCurrentStyleObj) && Object.keys(_vm.computedCurrentStyleObj).length > 0 ? [_vm.tableInitInfo.tableUsage === "control" ? _c("a-checkbox-group", {
    staticStyle: {
      width: "100%",
      "text-align": "right",
      "margin-top": "5px"
    },
    model: {
      value: _vm.computedCurrentStyleObj.preAndLast,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "preAndLast", $$v);
      },
      expression: "computedCurrentStyleObj.preAndLast"
    }
  }, [_c("a-checkbox", {
    attrs: {
      value: "prefix"
    }
  }, [_vm._v(_vm._s(_vm.$t("前缀")))]), _c("a-checkbox", {
    attrs: {
      value: "suffix"
    }
  }, [_vm._v(_vm._s(_vm.$t("后缀")))])], 1) : _vm._e(), _vm.tableInitInfo.tableUsage === "control" ? _c("div", {
    staticClass: "pre-and-suffix"
  }, [_vm.computedCurrentStyleObj.preAndLast.indexOf("prefix") !== -1 ? _c("a-input", {
    ref: "prefixInput",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("前缀")
    },
    on: {
      click: function ($event) {
        return _vm.handleAddPrefixSuffix("prefix");
      }
    },
    model: {
      value: _vm.computedCurrentStyleObj.prefix,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "prefix", $$v);
      },
      expression: "computedCurrentStyleObj.prefix"
    }
  }) : _vm._e(), _c("a-input", {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      value: _vm.computedValue(_vm.computedCurrentStyleObj.control),
      readOnly: true,
      placeholder: _vm.$t("请输入文本")
    }
  }), _vm.computedCurrentStyleObj.preAndLast.indexOf("suffix") !== -1 ? _c("a-input", {
    ref: "suffixInput",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("后缀")
    },
    on: {
      click: function ($event) {
        return _vm.handleAddPrefixSuffix("suffix");
      }
    },
    model: {
      value: _vm.computedCurrentStyleObj.suffix,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "suffix", $$v);
      },
      expression: "computedCurrentStyleObj.suffix"
    }
  }) : _vm._e()], 1) : _vm._e(), _c("div", {
    staticClass: "style-setting"
  }, [_vm._v(" " + _vm._s(_vm.$t("样式设置") + ":") + " "), _c("svg-icon", {
    class: ["style-setting-icon", _vm.computedCurrentStyleObj["font"] ? "select-icon" : ""],
    attrs: {
      icon: "font",
      size: 18
    },
    nativeOn: {
      click: function ($event) {
        return _vm.cellStyleSetting("font");
      }
    }
  }), _c("a-icon", {
    class: ["style-setting-icon", _vm.computedCurrentStyleObj["bold"] ? "select-icon" : ""],
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      type: "bold"
    },
    on: {
      click: function ($event) {
        return _vm.cellStyleSetting("bold");
      }
    }
  }), _c("a-icon", {
    class: ["style-setting-icon", _vm.computedCurrentStyleObj["italic"] ? "select-icon" : ""],
    attrs: {
      type: "italic"
    },
    on: {
      click: function ($event) {
        return _vm.cellStyleSetting("italic");
      }
    }
  }), _c("a-icon", {
    class: ["style-setting-icon", _vm.computedCurrentStyleObj["underline"] ? "select-icon" : ""],
    attrs: {
      type: "underline"
    },
    on: {
      click: function ($event) {
        return _vm.cellStyleSetting("underline");
      }
    }
  }), _c("a-icon", {
    class: ["style-setting-icon", _vm.computedCurrentStyleObj["fontSize"] ? "select-icon" : ""],
    attrs: {
      type: "font-size"
    },
    on: {
      click: function ($event) {
        return _vm.cellStyleSetting("fontSize");
      }
    }
  }), _c("a-icon", {
    class: ["style-setting-icon", _vm.computedCurrentStyleObj.activeStyleIcon === "bgColor" ? "select-icon" : ""],
    attrs: {
      type: "bg-colors"
    },
    on: {
      click: function ($event) {
        return _vm.cellStyleSetting("bgColor");
      }
    }
  }), _c("a-icon", {
    attrs: {
      type: "highlight"
    },
    on: {
      click: function ($event) {
        return _vm.cellStyleSetting("textAlign");
      }
    }
  })], 1), _c("div", {
    staticStyle: {
      width: "100%",
      "margin-top": "10px"
    }
  }, [_vm.computedCurrentStyleObj.activeStyleIcon === "bgColor" ? _c("el-color-picker", {
    attrs: {
      size: "mini"
    },
    on: {
      change: _vm.handleBgColorChange
    },
    model: {
      value: _vm.computedCurrentStyleObj.bgColorValue,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "bgColorValue", $$v);
      },
      expression: "computedCurrentStyleObj.bgColorValue"
    }
  }) : _vm._e(), _vm.computedCurrentStyleObj.activeStyleIcon === "textAlign" ? _c("a-select", {
    ref: "select",
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.computedCurrentStyleObj.valign,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "valign", $$v);
      },
      expression: "computedCurrentStyleObj.valign"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "center"
    }
  }, [_vm._v(_vm._s(_vm.$t("居中对齐")))])], 1) : _vm._e(), _vm.computedCurrentStyleObj.activeStyleIcon === "font" ? _c("a-select", {
    ref: "select",
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.computedCurrentStyleObj.typeFace,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "typeFace", $$v);
      },
      expression: "computedCurrentStyleObj.typeFace"
    }
  }, _vm._l(_vm.fontFamilySelectOption, function (item) {
    return _c("a-select-option", {
      key: item,
      attrs: {
        value: item
      }
    }, [_vm._v(_vm._s(item === "默认字体" ? _vm.$t("默认字体") : item))]);
  }), 1) : _vm._e(), _vm.computedCurrentStyleObj.activeStyleIcon === "fontSize" && _vm.computedCurrentStyleObj["fontSize"] ? _c("a-select", {
    ref: "select",
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.computedCurrentStyleObj.size,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "size", $$v);
      },
      expression: "computedCurrentStyleObj.size"
    }
  }, _vm._l(_vm.fontSizeSelectOption, function (item) {
    return _c("a-select-option", {
      key: item,
      attrs: {
        value: item
      }
    }, [_vm._v(_vm._s(item === "默认字号" ? _vm.$t("默认字号") : item))]);
  }), 1) : _vm._e()], 1), _vm.tableInitInfo.tableUsage === "control" ? _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("控件"),
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("控件"),
      allowClear: ""
    },
    on: {
      change: e => _vm.controlChange(e, _vm.computedCurrentStyleObj)
    },
    model: {
      value: _vm.computedCurrentStyleObj.control,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "control", $$v);
      },
      expression: "computedCurrentStyleObj.control"
    }
  }, _vm._l(_vm.controlCellOptions, function (item) {
    return _c("a-select-option", {
      key: item.value,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(_vm.$t(item.label)))]);
  }), 1)], 1) : _vm._e(), _vm.computedCurrentStyleObj.control && _vm.tableInitInfo.tableUsage === "control" ? _c("div", {
    staticStyle: {
      margin: "5px 10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("范围:")) + " ")]) : _vm._e(), _vm.tableInitInfo.tableUsage === "control" ? [_vm.computedCurrentStyleObj.control === "text" ? _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("字数限制"),
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: 0,
      max: _vm.computedCurrentStyleObj.textLengthMaxValue
    },
    model: {
      value: _vm.computedCurrentStyleObj.textLengthMinValue,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "textLengthMinValue", $$v);
      },
      expression: "computedCurrentStyleObj.textLengthMinValue"
    }
  }), _vm._v(" " + _vm._s("-") + " "), _c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: 0,
      max: 200
    },
    model: {
      value: _vm.computedCurrentStyleObj.textLengthMaxValue,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "textLengthMaxValue", $$v);
      },
      expression: "computedCurrentStyleObj.textLengthMaxValue"
    }
  })], 1) : _vm._e(), _vm.computedCurrentStyleObj.control === "radio" ? _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("选项值"),
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请填写控件选项，不同选项用“;”隔开(英文)")
    },
    model: {
      value: _vm.computedCurrentStyleObj.optionValues,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "optionValues", $$v);
      },
      expression: "computedCurrentStyleObj.optionValues"
    }
  })], 1) : _vm._e(), _vm.computedCurrentStyleObj.control === "date" ? _c("a-row", [_c("a-select", {
    staticStyle: {
      width: "100%",
      "margin-top": "5px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("日期格式")
    },
    model: {
      value: _vm.computedCurrentStyleObj.dateType,
      callback: function ($$v) {
        _vm.$set(_vm.computedCurrentStyleObj, "dateType", $$v);
      },
      expression: "computedCurrentStyleObj.dateType"
    }
  }, _vm._l(_vm.dateTypeOptions, function (item) {
    return _c("a-select-option", {
      key: item,
      attrs: {
        value: item
      }
    }, [_vm._v(_vm._s(item))]);
  }), 1)], 1) : _vm._e()] : _vm._e()] : _c("div", {
    staticClass: "empty-cell-settting"
  }, [_c("a-icon", {
    staticStyle: {
      "font-size": "30px",
      color: "#ffbc31",
      "margin-top": "40px"
    },
    attrs: {
      type: "alert"
    }
  }), _c("div", [_vm._v(_vm._s(_vm.$t("请先选中预览区单元格！")))])], 1)], 2), _c("div", {
    staticClass: "title-part"
  }, [_vm._v(" " + _vm._s(_vm.$t("数据处理")) + " "), _c("svg-icon", {
    staticClass: "quick-config-icon",
    attrs: {
      icon: "quick",
      size: 20
    },
    nativeOn: {
      click: function ($event) {
        return _vm.toQuickConfig.apply(null, arguments);
      }
    }
  })], 1), _c("div", {
    staticClass: "setting-sort-class"
  }, [_vm._v(" " + _vm._s(_vm.$t("列表排序") + "：" + _vm.$t("按照")) + " "), _c("a-select", {
    staticStyle: {
      width: "80px"
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      disabled: _vm.tableInitInfo.tableType === "fixed",
      dropdownClassName: "sort-field-select",
      allowClear: ""
    },
    on: {
      select: e => _vm.sortFieldSelect(e)
    },
    model: {
      value: _vm.tableForm.sortField,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "sortField", $$v);
      },
      expression: "tableForm.sortField"
    }
  }, _vm._l(_vm.sortColumns, function (item) {
    return _c("a-select-option", {
      key: item.dataIndex,
      attrs: {
        value: item.dataIndex
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm._v(" " + _vm._s(_vm.$t("的")) + " "), _c("a-select", {
    staticStyle: {
      width: "80px"
    },
    attrs: {
      placeholder: _vm.$t("请选择"),
      disabled: _vm.tableInitInfo.tableType === "fixed",
      dropdownClassName: "sort-rule-select",
      allowClear: ""
    },
    model: {
      value: _vm.tableForm.sort,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "sort", $$v);
      },
      expression: "tableForm.sort"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "ASC"
    }
  }, [_vm._v(_vm._s(_vm.$t("正序")))]), _c("a-select-option", {
    attrs: {
      value: "DESC"
    }
  }, [_vm._v(_vm._s(_vm.$t("倒序")))])], 1)], 1), _c("div", [_vm.tableInitInfo.tableType === "fixed" ? _c("a-checkbox", {
    staticStyle: {
      float: "right",
      "margin-bottom": "5px"
    },
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.tableForm.sortDefault,
      callback: function ($$v) {
        _vm.$set(_vm.tableForm, "sortDefault", $$v);
      },
      expression: "tableForm.sortDefault"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("默认")) + " ")]) : _vm._e()], 1), _vm._l(_vm.showFunctionResource, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "function-item",
      attrs: {
        title: item.name + ":" + item.mark
      }
    }, [_c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.tipDescription) + " ")]), _c("a-icon", {
      staticClass: "function-tip-icon",
      attrs: {
        type: "info-circle"
      }
    })], 2), item.mark === "SUM" ? _c("a", {
      staticClass: "function-name",
      on: {
        click: function ($event) {
          return _vm.toQuickConfig(item.mark);
        }
      }
    }, [_vm._v(_vm._s(item.name + ":" + item.mark))]) : _c("span", [_vm._v(_vm._s(item.name + ":" + item.mark))]), item.mark !== "SUM" ? _c("svg-icon", {
      staticClass: "copy-function-btn",
      attrs: {
        icon: "copy",
        size: 20
      },
      nativeOn: {
        click: function ($event) {
          return (e => _vm.copyFunction2(e, item)).apply(null, arguments);
        }
      }
    }) : _vm._e()], 1);
  }), _vm.configVisiable ? _c("quick-configuration-modal", {
    attrs: {
      configVisiable: _vm.configVisiable,
      type: "table"
    },
    on: {
      "update:configVisiable": function ($event) {
        _vm.configVisiable = $event;
      },
      "update:config-visiable": function ($event) {
        _vm.configVisiable = $event;
      }
    }
  }) : _vm._e()], 2), _c("a-modal", {
    attrs: {
      title: _vm.addType === "prefix" ? _vm.$t("前缀") : _vm.addType === "suffix" ? _vm.$t("后缀") : "",
      visible: _vm.addPrefixOrSuffixVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 600
    },
    on: {
      ok: _vm.handleSure,
      cancel: _vm.cancelAdd
    }
  }, [_c("a-textarea", {
    staticClass: "email-box",
    attrs: {
      "max-length": 200
    },
    model: {
      value: _vm.prefixOrSuffix,
      callback: function ($$v) {
        _vm.prefixOrSuffix = $$v;
      },
      expression: "prefixOrSuffix"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };